import React from "react";
import ReactModalWrap from "../common/ReactModalWrap";
import styles from "./Modal.module.scss";
import downloadIcon from "../../static/images/download-icon.svg";
import Button from "../common/Button";
import { newFiscalJPGDownload, newFiscalPdfDownload } from "../utils";

function MultiInvoiceModal({ close, invoiceList }) {
  if (!invoiceList) return null;
  console.log(invoiceList);
  return (
    <ReactModalWrap isOpen={invoiceList} close={close}>
      <div className={styles.content}>
        <div className={styles.header}>Download multiple invoices</div>
        {invoiceList?.map((invoice, i) => (
          <div className={styles.multiInvoiceItem} key={i}>
            <div className={styles.multiInvoiceItemHeader}>#{invoice.id}</div>
            <Button
              onClick={() => {
                newFiscalJPGDownload([invoice]);
              }}
              className={styles.downloadInvoiceButton}
              variant="white">
              <img height={16} src={downloadIcon} alt="download icon" />
              jpg
            </Button>
            <Button
              onClick={() => {
                newFiscalPdfDownload([invoice]);
              }}
              className={styles.downloadInvoiceButton}
              variant="white">
              <img height={16} src={downloadIcon} alt="download icon" />
              pdf
            </Button>
            <hr />
          </div>
        ))}
      </div>
    </ReactModalWrap>
  );
}

export default MultiInvoiceModal;
